import { html, rune, View } from 'rune-ts';
import klass from './MotionSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';

export class MotionSection extends View {
  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    return html`
      <section class="${klass.motion}">
        <div class="${klass.video_container}">
          <div class="${klass.video_wrapper}">
            <video
              autoplay=""
              loop=""
              muted=""
              playsinline=""
              class="${klass.motion_video}"
              src="//s3.marpple.co/files/u_14345/2024/6/original/${is_mobile
                ? 'mo-'
                : ''}popupstore-landing-motion.mp4"
            ></video>
            <div class="${klass.background}"></div>
          </div>
        </div>

        <div class="${klass.motion_description}">
          <h4 class="${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_medium' })}">
            ${ET('mps2::landing::popup_store::motion_description')}
          </h4>
          <h1 class="${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${html.preventEscape(ET('mps2::landing::popup_store::motion_title'))}
          </h1>
        </div>
      </section>
    `;
  }
}
